<template>
  <el-container v-cloak v-loading="loading" element-loading-background="#545c64">
    <el-aside class="side-menu" :style="{width: (isCollapse ? '67px' : '200px')}">
      <div class="logo-container">
        <img src="/img/logo.jpg" style="height: 40px;" />
      </div>
      <el-menu
        :default-active="$router.currentRoute.path"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
        ref="menu"
        :router="true"
        :collapse="isCollapse"
      >
        <el-menu-item
          index="/"
          v-if="user.role && user.role.privileges.indexOf('ADMIN_CONSOLE') > -1"
        >
          <i class="el-icon-menu"></i>
          <span>Admin Console</span>
        </el-menu-item>
        <el-menu-item
          index="/device"
          v-if="user.role && user.role.privileges.indexOf('REPOSSESSED_DEVICE') > -1"
        >
          <i class="el-icon-mobile-phone"></i>
          <span>Repossessed Device</span>
        </el-menu-item>
        <el-submenu
          index="launcher-management"
          v-if="user.role && (user.role.privileges.indexOf('WEB_FORM_MANAGEMENT') > -1 || 
                        user.role.privileges.indexOf('ACTIVATION_POLICY_MANAGEMENT') > -1)"
        >
          <template slot="title">
            <i class="el-icon-mobile-phone"></i>
            <span>SR Launcher</span>
          </template>
          <el-menu-item
            index="/launcher/web-form"
            v-if="user.role && user.role.privileges.indexOf('WEB_FORM_MANAGEMENT') > -1"
          >Web Form</el-menu-item>
          <!-- <el-menu-item
            index="/launcher/activation-policy"
            v-if="user.role && user.role.privileges.indexOf('ACTIVATION_POLICY_MANAGEMENT') > -1"
          >Activation Policy</el-menu-item> -->
        </el-submenu>
        <el-submenu
          index="user-management"
          v-if="user.role && (user.role.privileges.indexOf('USER_MANAGEMENT') > -1 || 
                      user.role.privileges.indexOf('USER_ROLE_MANAGEMENT') > -1)"
        >
          <template slot="title">
            <i class="el-icon-user-solid"></i>
            <span>User</span>
          </template>
          <el-menu-item
            index="/users"
            v-if="user.role && user.role.privileges.indexOf('USER_MANAGEMENT') > -1"
          >User List</el-menu-item>
          <el-menu-item
            index="/users/manage"
            v-if="user.role && user.role.privileges.indexOf('USER_MANAGEMENT') > -1"
          >New User</el-menu-item>
          <el-menu-item
            index="/roles"
            v-if="user.role && user.role.privileges.indexOf('USER_ROLE_MANAGEMENT') > -1"
          >User Roles</el-menu-item>
        </el-submenu>

        <el-submenu
          index="master-setting"
          v-if="user.role && (user.role.privileges.indexOf('COUNTRY_MANAGEMENT') > -1 || 
                      user.role.privileges.indexOf('CITY_MANAGEMENT') > -1 || 
                      user.role.privileges.indexOf('OFFICE_MANAGEMENT') > -1 || 
                      user.role.privileges.indexOf('DEPARTMENT_MANAGEMENT') > -1 || 
                      user.role.privileges.indexOf('SR_COUNTRY_MANAGEMENT') > -1 || 
                      user.role.privileges.indexOf('EMAIL_MANAGEMENT') > -1)"
        >
          <template slot="title">
            <i class="el-icon-setting"></i>
            <span>Settings</span>
          </template>
          <el-menu-item
            index="/settings/office-country"
            v-if="user.role && user.role.privileges.indexOf('COUNTRY_MANAGEMENT') > -1"
          >Office Country</el-menu-item>
          <el-menu-item
            index="/settings/office-city"
            v-if="user.role && user.role.privileges.indexOf('CITY_MANAGEMENT') > -1"
          >Office City</el-menu-item>
          <el-menu-item
            index="/settings/office-name"
            v-if="user.role && user.role.privileges.indexOf('OFFICE_MANAGEMENT') > -1"
          >Office Name</el-menu-item>
          <el-menu-item
            index="/settings/office-department"
            v-if="user.role && user.role.privileges.indexOf('DEPARTMENT_MANAGEMENT') > -1"
          >Department</el-menu-item>
          <el-menu-item
            index="/settings/sr-country"
            v-if="user.role && user.role.privileges.indexOf('SR_COUNTRY_MANAGEMENT') > -1"
          >GSR Country</el-menu-item>
          <el-menu-item
            index="/settings/preference"
            v-if="user.role && user.role.privileges.indexOf('EMAIL_MANAGEMENT') > -1"
          >Email Server</el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header class="bg-primary navbar" v-cloak>
        <div class="float-left text-xl text-white cursor-pointer">
          <span @click="isCollapse = !isCollapse">
            <i :class="{'el-icon-s-fold' : !isCollapse, 'el-icon-s-unfold' : isCollapse}"></i>
          </span>
        </div>

        <div class="right-menu">
          <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
            <div class="avatar-wrapper">
              <i class="el-icon-user-solid mr-2" />
              <span>
                <span v-if="user.lastName !== '' && user.lastName != null">{{user.lastName}} ,</span>
                {{user.firstName}}
              </span>
              <i class="el-icon-caret-bottom" />
            </div>
            <el-dropdown-menu slot="dropdown">
              
              <a @click="resetPassword">
                <el-dropdown-item>Reset Password</el-dropdown-item>
              </a>
              <el-dropdown-item divided>
                <span style="display:block;" @click="logoutUser">Log Out</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <el-main>
        <transition>
          <router-view :key="$route.fullPath"></router-view>
        </transition>
      </el-main>

      <el-footer>
        <div class="text-right border-t">&copy; 2019 - Tech Creatures Sdn. Bhd.</div>
      </el-footer>
    </el-container>
    <el-dialog title="Reset Password" :visible.sync="showResetPw" >
        <el-form :model="resetForm" ref="resetForm" :rules="resetRules" v-loading="reseting">
            <el-form-item :required="true" label="New Password" :label-width="formLabelWidth" prop="newPassword">
                <el-input type="password" v-model="resetForm.newPassword"></el-input>
            </el-form-item>
            <el-form-item :required="true" label="Confirm New Password" :label-width="formLabelWidth" prop="confirmNewPassword">
                <el-input type="password" v-model="resetForm.confirmNewPassword"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="showResetPw = false">Close</el-button>
            <el-button size="small" type="primary" @click="doResetPassword()">Reset</el-button>
        </span>
    </el-dialog>
  </el-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import _ from "lodash";
import api from "@/services/api/WRCService"

//import '../public/img/logo.jpg'

export default {
  name: 'app',
  data: function() {
    var validateNewPassword = (rule, value, callback) => {
        if (!value) {
            callback(new Error('Please enter New Password'));
        } else {
            if (value.length < 6) {
              callback(new Error('Password must at least 6 character long'));
            } else {
              callback();
            }
        }
    };
    var validateConfirmNewPassword = (rule, value, callback) => {
        if (!value) {
            callback(new Error('Please enter Confirm New Password'));
        } else {
          if (value != this.resetForm.newPassword) {
            callback(new Error('Confirm New Password didn\'t match with New Password'));
          } else {
            callback();
          }
        }
    };
    return {
      resetRules: {
          newPassword: [
              { validator: validateNewPassword, trigger: 'blur' }
          ],
          confirmNewPassword: [
              { validator: validateConfirmNewPassword, trigger: 'blur' }
          ]
      },
      reseting: false,
      isCollapse: false,
      showResetPw: false,
      loading: true,
      formLabelWidth: '250px',
      resetForm: {
        newPassword: '',
        confirmNewPassword: ''
      }
    }
  },
  computed: {
    ...mapState([
        'user'
    ])
  },
  methods: {
    ...mapActions([
      'logout'
    ]),
    logoutUser() {
      this.logout()
    },
    resetPassword() {
      this.resetForm.newPassword = '';
      this.resetForm.confirmNewPassword = '';

      setTimeout(() => {
          if (!_.isUndefined(this.$refs['resetForm'])) {
              this.$refs['resetForm'].clearValidate();
          }
      }, 1);

      this.showResetPw = true
    },
    doResetPassword() {
      this.$refs['resetForm'].validate((valid) => {
        if (valid) {
          this.reseting = true

          let params = {
              password: this.resetForm.newPassword,
          }

          api.resetUserPassword(params).then(({data}) => {
              this.$message({
                  message: 'Successfully Reset User Password.',
                  type: 'success'
              })
          }).catch(() => {
          }).then(() => {
              this.reseting = false
              this.showResetPw = false
          })
        }
      })
    }
  },
  mounted() {

    this.loading = false;
  }
}

</script>

<style lang="scss" scoped>
.el-main {
  /*padding-bottom: 100px;*/
}

.el-footer {
  padding-left: 1em;
  padding-right: 1em;
}

.el-footer {
  line-height: 60px;
  font-size: 12px;
}

.v-cloak {
  display: none;
}

.el-dropdown-menu {
  a {
    text-decoration: none;
  }
}

.navbar {
  /*height: 50px;*/
  /*overflow: hidden;*/
  /*position: relative;*/
  /*background: #fff;*/
  /*box-shadow: 0 1px 4px rgba(0,21,41,.08);*/

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 60px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 15px;
      color: white;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>